<template lang="html">
  <div>
    <b-col md="12">
      <b-card>
        <div class="table-responsive-sm">
          <table class="table b-table table-striped" style="margin-bottom:0px">
              <tbody class="">
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="80" style="background-color:#f1f1f1">
                          <label class="col-form-label">대분류</label>
                      </td>
                      <td class="">
                          <b-form-select id="basicSelect"
                                         v-model="reportPopSearchData.top_type_code"
                                         v-on:change="selectSubOptionResult()"
                                         :plain="true"
                                         :options="searchTopDepths"
                                         :value="null"/>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="80" style="background-color:#f1f1f1">
                          <label class="col-form-label">소분류</label>
                      </td>
                      <td class="">
                          <b-form-select id="basicSelect"
                                         v-model="reportPopSearchData.type_code"
                                         :disabled="subOptionCheck"
                                         :plain="true"
                                         :options="searchSubDepths"
                                         :value="null"/>
                      </td>
                  </tr>

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="80" style="background-color:#f1f1f1">
                        <label class="col-form-label">등록일</label>
                      </td>
                      <td class="">
                          <b-row class="pt-sm-12">
                              <b-col sm="4"><b-form-input type="text" name="datepicker" :disabled="reportPopSearchData.day_code == 'dayall'" /></b-col>
                              <b-col sm="8">
                                  <b-button class="mx-1" variant="outline-primary"
                                            v-for="(dateMonthBtn, idx) in popDateMonthButtons"
                                            v-on:click="dateMonthSelect(dateMonthBtn)"
                                            :key="idx"
                                            :pressed.sync="dateMonthBtn.state">
                                    {{ dateMonthBtn.item_name }}
                                  </b-button>
                              </b-col>
                          </b-row>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="80" style="background-color:#f1f1f1">
                         <label class="col-form-label">키워드</label>
                      </td>
                      <td class="">
                          <b-row class="pt-sm-12">
                             <b-col sm="12">
                               <b-form-input id="basicText" type="text" placeholder="보고서명 및 옵션명을 입력해주세요."
                                             v-model="reportPopSearchData.keyword"
                                             v-on:keyup="$event.keyCode === 13 ? findDrReportOptList() : ''"/>
                             </b-col>
                          </b-row>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="80" style="background-color:#f1f1f1">
                      <label class="col-form-label">구분</label>
                    </td>
                    <td class="">
                      <b-row class="pt-sm-12">
                        <b-col sm="12">
                            <b-form-radio-group v-model="reportPopSearchData.sales_type">
                              <b-form-radio value="all">전체</b-form-radio>
                              <b-form-radio value="pay">유료</b-form-radio>
                              <b-form-radio value="free">무료</b-form-radio>
                            </b-form-radio-group>
                        </b-col>
                      </b-row>
                    </td>
                  </tr>
              </tbody>
          </table>
          <div style="float:right; padding:5px">
            <b-button type="submit" variant="success" v-on:click="findDrReportOptList()">
              <i class="fa fa-dot-circle-o"/>검색
            </b-button>
          </div>
        </div>
      </b-card>


      <b-card style="padding:0px">
          <div style="background-color: black;width: 100%;height: 100%;display: block;position: absolute;left: 0px;top: 0px; opacity: 0.2" v-on:click="pkgRowsData = []; $refs.pkgTable.refresh()" v-show="pkgRowsData.length > 0">
              <p style="width: 100%;height: 100%;display: block;position: absolute;left: 35%;top: 37%; color:#ffffff; font-weight:bold; font-size:20px">패키지 포함 목록 선택중</p>
          </div>

          <div slot="header">보고서 리스트 (적용전 상품) (총 {{reportOptions.optItems.length}}건)</div>
          <div class="opt-table">
              <b-table style="margin-bottom:0px" striped hover bordered selectable ref="optTable" selectedVariant="success" @row-selected="optSelected"
                       :select-mode="selectMode"
                       :fields="optfieldItems"
                       :items="reportOptions.optItems"
                       :busy="reportOptions.optItems == 0">
                  <div slot="table-busy" class="text-center my-2">
                    <strong>데이터가 없습니다.</strong>
                  </div>
              </b-table>
          </div>
      </b-card>
    </b-col>

    <div class="card" style="border: 0px; margin:-23px 0 -5px 0">
        <div class="card-body" style="padding: 0px">
            <div style="margin: 0px auto; display: block; width: 0%">
<!--                <p style="float: left; font-size: 55px" :style="optRowsData.length > 0 ? 'opacity: 0.2' : (optRowsData.length == 0 && pkgRowsData.length == 0) ? 'opacity: 0.2': ''">
                    &lt;!&ndash; 주옵션으로 이동 &ndash;&gt;
                    <a href="javascript:void(0)" v-on:click="optOptionsGo()" v-show="(optRowsData.length > 0 && pkgRowsData.length > 0) || (optRowsData.length == 0 && pkgRowsData.length > 0)">
                      <i class="fa fa-hand-o-up fa-lg mt-4"/>
                    </a>
                    <i class="fa fa-hand-o-up fa-lg mt-4" v-show="optRowsData.length > 0 || (optRowsData.length == 0 && pkgRowsData.length == 0)"/>
                </p>-->
                <p style="float: right; font-size: 55px" :style="pkgRowsData.length > 0 ? 'opacity: 0.2' : (optRowsData.length == 0 && pkgRowsData.length == 0) ? 'opacity: 0.2': ''">
                    <!-- 패키지로 이동 -->
                    <a href="javascript:void(0)" v-on:click="pkgOptionsGo()" v-show="(optRowsData.length > 0 && pkgRowsData.length > 0) || (pkgRowsData.length == 0 && optRowsData.length > 0)">
                      <i class="fa fa-hand-o-down fa-lg mt-4"/>
                    </a>
                    <i class="fa fa-hand-o-down fa-lg mt-4" v-show="pkgRowsData.length > 0  || (optRowsData.length == 0 && pkgRowsData.length == 0)"/>
                </p>
            </div>
        </div>
    </div>

    <b-col md="12">
        <b-card style="padding:0px">
            <div style="background-color: black;width: 100%;height: 100%;display: block;position: absolute;left: 0px;top: 0px; opacity: 0.2" v-on:click="optRowsData = []; $refs.optTable.refresh()" v-show="optRowsData.length > 0">
               <p style="width: 100%;height: 100%;display: block;position: absolute;left: 37%;top: 37%; color:#ffffff; font-weight:bold; font-size:20px">주옵션 목록 선택중</p>
            </div>
            <div slot="header" style="display: flex; justify-content: space-between;">
              <span>진열 상품</span>
              <button class="btn btn-danger" v-on:click="optOptionsGo()">삭제</button>
            </div>
            <div class="opt-table">
                <b-table style="margin-bottom:0px" striped hover bordered selectable ref="pkgTable" selectedVariant="success" @row-selected="pkgSelected"
                         :select-mode="selectMode"
                         :fields="pkgfieldItems"
                         :items="reportOptions.pkgItems"
                         :busy="reportOptions.pkgItems == 0">

                  <template slot="price_list" slot-scope="data">
                    <div style="width:200px; text-align: left;">
                      <div v-html="data.value"></div>
                    </div>
                  </template>

                  <div slot="table-busy" class="text-center my-2">
                      <strong>데이터가 없습니다.</strong>
                    </div>
                </b-table>
            </div>
        </b-card>
    </b-col>

  </div>
</template>

<script>
import { codeAPI } from '../../../../../common/code.js';
import swal from "sweetalert2";

export default {
  props: {
    reportOptions:{
      optItems: [],
      pkgItems: [],
      pkgOptList: []
    },
    formModal:null,
  },
  data(){
    return {
      // 팝업 검색 객체
      reportPopSearchData: {
        day_code: 'dayall',
        top_type_code: 'all', // 대분류 코드
        type_code: 'all',     // 소분류 코드
        start_date: '',
        end_date: '',
        sales_type: 'all',
      },
      // 소분류 노출 조절, 대분류 선택시 활성화
      // true : 비황성화, false : 활성화
      subOptionCheck: true,

      selectMode: 'multi',
      selectTopTypeItems: [],
      selectTypeItems: [],

      // 대분류 뎁스 데이터
      searchTopDepths: [],

      // 소분류 뎁스 데이터
      searchSubDepths: [],

      // 선택한 옵션 데이터
      optRowsData: [],

      // 선택한 패키지 데이터
      pkgRowsData: [],

      ///////////// 검색 세팅 데이터
      popDateMonthButtons: [
        { item_name: '전체', item_code:'dayall', state: true },
        { item_name: '오늘', item_code:'1|days',state: false },
        { item_name: '1주일', item_code:'7|days',state: false },
        { item_name: '1개월', item_code:'1|months',state: false },
        { item_name: '6개월', item_code:'6|months',state: false },
        { item_name: '1년', item_code:'1|years',state: false },
      ],
      calendarLocale: {
        "format": "YYYY-MM-DD",
        "separator": "~",
        "applyLabel": "적용",
        "cancelLabel": "취소",
        "fromLabel": "From",
        "toLabel": "To",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
          "일", "월", "화", "수", "목", "금", "토"
        ],
        "monthNames": [
          "1월", "2월", "3월", "4월", "5월", "6월",
          "7월", "8월", "9월", "10월", "11월", "12월"
        ],
        "firstDay": 1
      },
      optfieldItems: [{
        'display_ord': {
          'label': '번호',
          'class': 'text-center'
        }
      }, {
        'report_name': {
          'label': '보고서 명',
          'class': 'text-left'
        }
      }, {
        'dr_code': {
          'label': '상품코드',
          'class': 'text-center'
        }
      }, {
        'reg_date': {
          'label': '등록일',
        }
      }],

      pkgfieldItems: [{
        'display_ord': {
          'label': '번호',
          'class': 'text-center'
        }
      }, {
        'report_name': {
          'label': '보고서 명',
          'class': 'text-left'
        }
      }, {
        'dr_code': {
          'label': '상품코드',
          'class': 'text-center'
        }
      }, {
        'price_list': {
          'label': '가격',
          'class': 'text-center'
        }
      }, {
        'reg_date': {
          'label': '적용일',
        }
      }]
    }
  },

  watch: {
    formModal () {
      var self = this;

      // 열고 닫을 때마다 선택 값 초기화
      self.optRowsData = [];
      self.pkgRowsData = [];
      self.$refs.optTable.refresh();
      self.$refs.pkgTable.refresh();
      // 팝업이 열릴 때마다 넘버링 초기화
      if (self.formModal) {
        self.reportOptions.optItems.forEach(function (el, idx, arr){
          el.display_ord = (idx + 1);
        });
        self.reportOptions.pkgItems.forEach(function (el, idx, arr){
          el.display_ord = (idx + 1);
        });
      }
    },
  },
  mounted: function() {
    var self = this;
    var resultDatas = [];

    codeAPI.selectItemCodeList(self,"RPT_TYPE",2,"selectTopTypeItems");

    setTimeout(function(){
      resultDatas.push({text: '전체',value: 'all'});
      self.selectTopTypeItems.forEach(function (el, idx, arr){
        var items = {
          text: el.item_name,
          value: el.item_code,
        };
        resultDatas.push(items);
      });
      self.searchTopDepths = resultDatas;
      self.searchSubDepths.push({text: '전체',value: 'all'});
      self.reportPopSearchData.top_type_code = 'all';
      self.reportPopSearchData.type_code = 'all';
    }, 500);

    $(function() {
      $('input[name="datepicker"]').daterangepicker({
        opens: 'left',
        "locale": self.calendarLocale,
        "endDate": moment().format('YYYY-MM-DD'),
        "startDate": moment().add(0, 'days').format('YYYY-MM-DD')
      }, function(start, end, label) {
        self.reportPopSearchData.start_date = start.format('YYYY-MM-DD');
        self.reportPopSearchData.end_date = end.format('YYYY-MM-DD');
      });
    });
  },
  methods: {
    // ### 리포트 조회 ###
    // 리포트를 DB테이블에서 조회한다.
    findDrReportOptList() {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(self.reportPopSearchData));

      var data = new FormData();
      data.append('optObjs', param);

      self.$http.post('/api/select/drReportSearchOptListForCuration?access_token=' + token, data, null)
        .then((result) => {
          self.reportOptions.optItems = result.data;
          self.reportOptions.optItems.forEach(function (el, idx, arr){
            el.display_ord = (idx+1);
          });
        })
    },


    // 대분류 선택
    selectSubOptionResult() {
      var self = this;
      var resultDatas = [];
      self.subOptionCheck = true;

      // 대분류 전체 선택을 하지 않았다면, 대분류에 맞는 소분류 데이터를
      // 가져와서 소뷴류 selectbox에 세팅 (selectTypeItems)
      if(self.reportPopSearchData.top_type_code != "all"){
        codeAPI.selectItemCodeList(self,self.reportPopSearchData.top_type_code,3,"selectTypeItems");
        setTimeout(function(){

          // 전체 선택 가능하게 강제 세팅
          resultDatas.push({text: '전체',value: 'all'});

          // api 리턴값 세팅
          self.selectTypeItems.forEach(function (el, idx, arr){
            var items = {text: el.item_name, value: el.item_code}
            resultDatas.push(items);
          });

          // 리턴값 소뷴류 뎁스에 할당
          self.searchSubDepths = resultDatas;

          // 소분류 첫번째 값으로 세팅
          self.reportPopSearchData.type_code = self.searchSubDepths[0].value;
          self.subOptionCheck = false;
        }, 500);

      }else{
        self.reportPopSearchData.type_code = 'all';
      }
    },
    // @row-seleted로 선택한 옵션 list 전달 받음
    optSelected(items) {
      this.optRowsData = items;
    },

    // @row-seleted로 선택한 패키지 list 전달 받음
    pkgSelected(items) {
      this.pkgRowsData = items;
    },

    // 삭제
    optOptionsGo() {
      var self = this;
      self.pkgRowsData.forEach(function (el, idx, arr){

        // 선택 되어 아래로 내려간 옵션 리스트 확인
        self.reportOptions.pkgItems.forEach(function (t_el, t_idx, t_arr){
          // 이미 선택되어 있다면 삭제
          if(el.dr_code == t_el.dr_code){
            self.reportOptions.pkgItems.splice(t_idx, 1);
          }
        });
        //self.reportOptions.optItems.push(el);
      });

      //진열 순서 리셋
      self.reportOptions.pkgItems.forEach(function (el, idx, arr){
        el.display_ord = (idx + 1);
      });

    },

    // 패키지 선택
    pkgOptionsGo() {
      var self = this;

      let pkg_len = self.reportOptions.pkgItems.length;
      let opt_len = self.optRowsData.length;
      if ((pkg_len + opt_len) > 4){
        swal.fire('등록 가능한 보고서는 최대 4개입니다.', '', 'error');
        return;
      }

      self.optRowsData.forEach(function (el, idx, arr){
        // 선택 되어 아래로 내려간 패키지 리스트 확인
        self.reportOptions.optItems.forEach(function (t_el, t_idx, t_arr){

          // 이미 선택되어 있다면 삭제
          if(el.dr_code == t_el.dr_code){
            self.reportOptions.optItems.splice(t_idx, 1);
          }

        });

        // pkgItems에 이미 동일한 dr_code를 가진 요소가 있는지 확인
        let isAlreadyExist = self.reportOptions.pkgItems.some(function(item){
          return item.dr_code === el.dr_code;
        });

        // 동일한 요소가 있으면 alert 띄우기
        if(isAlreadyExist){
          swal.fire('이미 진열 관리에 추가된 보고서가 존재합니다.', '', 'error');
        } else {
          // 동일한 요소가 없으면 pkgItems에 추가
          self.reportOptions.pkgItems.push(el);
        }

      });

      let price_list = '';
      self.reportOptions.pkgItems.forEach(function (el, idx, arr){
        price_list = '';
        price_list += '일반 PDF '+Number(el.min_normal_price).toLocaleString()+' ~ '+Number(el.max_normal_price).toLocaleString()+'원<br>';
        price_list += '원본 PDF '+Number(el.min_original_price).toLocaleString()+' ~ '+Number(el.max_original_price).toLocaleString()+'원<br>';
        price_list += '보안 PDF '+Number(el.min_security_price).toLocaleString()+' ~ '+Number(el.max_security_price).toLocaleString()+'원<br>';
        el.price_list = price_list;

        //진열 순서 리셋
        el.display_ord = (idx + 1);
      });
    },

    dateMonthSelect (item) {
      var self = this;
      self.popDateMonthButtons.forEach(function (el, idx, arr){
        if(el.item_code == item.item_code){
          el.state = true;
        }else{
          el.state = false;
        }
      });

      self.reportPopSearchData.day_code = item.item_code;
      var dateSpilt;
      dateSpilt = item.item_code.split("|");
      setTimeout(function(){
        $('input[name="datepicker"]').data('daterangepicker').setStartDate(moment().format('YYYY-MM-DD'));
        $('input[name="datepicker"]').data('daterangepicker').setEndDate(moment().add(dateSpilt[0], dateSpilt[1]).format('YYYY-MM-DD'));
        self.reportPopSearchData.start_date = moment().format('YYYY-MM-DD');
        self.reportPopSearchData.end_date = moment().add(dateSpilt[0], dateSpilt[1]).format('YYYY-MM-DD');
      }, 0);
    }
  }
}
</script>


<style scoped>
.formLabel{
  font-weight: 600;
}
.opt-table {
  max-height: 278px;
  overflow: auto;
}
.card-body {
  padding:0px
}
</style>



// WEBPACK FOOTER //
// src/views/site/main/component/curation/ReportOptModal.vue